import { render, staticRenderFns } from "./LicensesResumeCard.vue?vue&type=template&id=1ef23e15&scoped=true"
import script from "./LicensesResumeCard.vue?vue&type=script&lang=js"
export * from "./LicensesResumeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef23e15",
  null
  
)

export default component.exports